/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { TimeAvailabilityModel } from './time-availability.model';
import { DateTimeWithTimezoneModel } from '@irian-ro/date-utils';

export class RoutingSolutionMetadata extends JSONable {
  minimumTimeAvailability: TimeAvailabilityModel | undefined = undefined;

  routeStartTime: DateTimeWithTimezoneModel | undefined = undefined;

  routeEndTime: DateTimeWithTimezoneModel | undefined = undefined;
}
